import { ProductType, type TCard } from '@/models/chat.model';

import {
  StyledButton,
  StyledHeaderWrapper,
  StyledImagePlaceholder,
  StyledImageWrapper,
  StyledInfoWrapper,
  StyledPartNumber,
  StyledPrice,
  StyledProductCard,
  StyledProductCardBody,
  StyledProductCardDescription,
  StyledProductCardImage,
  StyledProductCardLink,
  StyledProductCardsList,
  StyledTitle,
} from './ProductCardsStyles';
import { useMemo } from 'react';
import { ArrowIcon, BoxIcon } from '@/icons';

// Helpers
import { renderMarkdown } from '../../helpers';

export interface IProductCardsProps {
  items: TCard[];
  primaryColor?: string;
}

const ProductCards = ({ items, primaryColor }: IProductCardsProps) => {
  const renderCards = useMemo(() => {
    return items.map((item) => (
      <StyledProductCard key={item.sku}>
        <StyledHeaderWrapper>
          <StyledImageWrapper>
            {item.image_url ?
            (
              <StyledProductCardImage
                src={item.image_url}
                alt="product img"
                loading="lazy"
              />
            )
            : (
              <StyledImagePlaceholder $primary={primaryColor}>
                <BoxIcon />
              </StyledImagePlaceholder>
            )
            }
          </StyledImageWrapper>
          <StyledInfoWrapper>
            <StyledTitle>{item.product_title ?? item.name}</StyledTitle>
            <StyledPartNumber>{item.oem_part_number}</StyledPartNumber>
            {!!item.price?.amount && parseFloat(item.price.amount) > 0 && (
              <StyledPrice>${item.price.amount}</StyledPrice>
            )}
          </StyledInfoWrapper>
        </StyledHeaderWrapper>
        <StyledProductCardBody>
          <StyledProductCardDescription
            dangerouslySetInnerHTML={{ __html: renderMarkdown(item.description ?? '') }}
          />
          <StyledProductCardLink href={item.url ?? ''} target="_blank" rel="noopener noreferrer">
            <StyledButton $primary={primaryColor}>
              {item.type === ProductType.MODEL ? 'View Model' : 'View Product'}
              <ArrowIcon />
            </StyledButton>
          </StyledProductCardLink>
        </StyledProductCardBody>
      </StyledProductCard>
    ));
  }, [items, primaryColor]);

  if (!items?.length) return null;

  return (
    <StyledProductCardsList>
      {renderCards}
    </StyledProductCardsList>
  );
};

export default ProductCards;
